import { render, staticRenderFns } from "./listino_fotoenlarge_desktop.vue?vue&type=template&id=787164f3&"
import script from "./listino_fotoenlarge_desktop.vue?vue&type=script&lang=js&"
export * from "./listino_fotoenlarge_desktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VDialog,VImg})
